/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
  inject,
  ElementRef,
} from '@angular/core'
import { MatInput } from '@angular/material/input'
import { FormUtils } from '@galabid/shared/utils/helpers'

@Component({
  selector: 'gb-form-field',
  templateUrl: './gb-form-field.component.html',
  styleUrls: ['./gb-form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GbFormFieldComponent {
  @Input({ required: true }) control!: any
  @Input() labelTranslateKey?: string
  @Input() hintTranslateKey?: string
  @Input() hintTemplate?: boolean
  @Input() placeholderTranslateKey?: string
  @Input() type = 'text'
  @Input() noMatchErrorTranslateKey?: string
  @Input() showRequiredError = true
  @Input() prefix?: string
  @Input() suffix?: string
  @Input() inputFormatter?: (value: string) => string
  @Input() maxLength?: number
  @Input() showCounter = false

  @Output() focus = new EventEmitter<void>()

  @Output() blur = new EventEmitter<void>()

  @Output() valueChange = new EventEmitter<any>()

  @ViewChild(MatInput) input!: MatInput

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    if (!this.inputFormatter) return

    const input = event.target as HTMLInputElement
    const formatted = this.inputFormatter(input.value)

    if (input.value !== formatted) {
      this.control.setValue(formatted, { emitEvent: false })
    }
  }

  public elementRef = inject(ElementRef)

  get currentLength(): number {
    const value = this.control?.value
    return typeof value === 'string' ? value.length : 0
  }

  focusInput() {
    if (this.input) {
      this.input.focus()
    }
  }

  onFocus(): void {
    this.focus.emit()
  }

  onBlur(): void {
    this.blur.emit()
  }

  getMaxLengthFromValidator(): number | null {
    return this.maxLength ?? FormUtils.getMaxLengthFromValidator(this.control)
  }
}
